import * as types from '../mutation-types'
import * as api from '../api'
import _ from 'lodash'

const state = {
  sounds: [],
  sound_types: [],
  sound_types_for_dropdown: []
}

const getters = {
  allSounds: state => state.sounds,
  allSoundTypes: state => state.sound_types,
  allSoundTypesForDropdown: state => state.sound_types_for_dropdown
}

const actions = {
  getSounds ({ commit, rootGetters }) {
    api.instance.get('sounds')
      .then(function (response) {
        let sounds = response.data.sounds

        for (let i = 0; i < sounds.length; i++) {
          sounds[i].alert = false
          sounds[i].announcement = false
          sounds[i].bell = false
          sounds[i].playlist = false
          sounds[i].scheduled = false

          if (sounds[i].tags.includes('alert')) {
            sounds[i].alert = true
          }

          if (sounds[i].tags.includes('announcement')) {
            sounds[i].announcement = true
          }

          if (sounds[i].tags.includes('bell')) {
            sounds[i].bell = true
          }

          if (sounds[i].tags.includes('playlist')) {
            sounds[i].playlist = true
          }

          if (sounds[i].tags.includes('scheduled')) {
            sounds[i].scheduled = true
          }
        }

        commit(types.RECEIVE_SOUNDS, sounds)
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  getSoundTypes ({ commit }) {
    if (!Array.isArray(state.sound_types) || !state.sound_types.length) {
      api.instance.get('sound_types')
        .then(function (response) {
          const soundTypes = response.data.sound_types
          commit(types.RECEIVE_SOUND_TYPES, soundTypes)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  uploadSoundFile ({ commit, rootGetters }, data) {
    let file = data.file
    let tags = data.tags
    let remove_after = data.remove_after

    let formData = new FormData()
    formData.append('sound', file)
    formData.append('site_id', rootGetters.scopedSiteId)
    if(remove_after) formData.append('remove_after', remove_after)

    // build tags string
    let tagsStr = ''

    if (tags.alert) {
      tagsStr += 'alert,'
    }
    if (tags.announcement) {
      tagsStr += 'announcement,'
    }
    if (tags.bell) {
      tagsStr += 'bell,'
    }
    if (tags.playlist) {
      tagsStr += 'playlist,'
    }
    if (tags.scheduled) {
      tagsStr += 'scheduled,'
    }
    tagsStr = tagsStr.slice(0, -1)

    formData.append('tags', tagsStr)
    const dialog = this._vm.g2dialog

    return api.instance.post('sounds', formData, { 'content-type': 'multipart/form-data' })
      .then(function (response) {
        if (response.data.success === 'true') {
          dialog.$alert('Sound file uploaded successfully!')

          response.data.sound[0].alert = false
          response.data.sound[0].announcement = false
          response.data.sound[0].bell = false
          response.data.sound[0].playlist = false

          if (response.data.sound[0].tags.includes('alert')) {
            response.data.sound[0].alert = true
          }

          if (response.data.sound[0].tags.includes('announcement')) {
            response.data.sound[0].announcement = true
          }

          if (response.data.sound[0].tags.includes('bell')) {
            response.data.sound[0].bell = true
          }

          if (response.data.sound[0].tags.includes('playlist')) {
            response.data.sound[0].playlist = true
          }
          if (response.data.sound[0].tags.includes('scheduled')) {
            response.data.sound[0].scheduled = true
          }

          commit(types.UPLOAD_SOUND, response.data.sound[0])
          return response.data.sound[0]
        } else {
          dialog.$alert(response.data.message)
          return Promise.reject(response.data.message)
        }
      })
  },
  setTags ({ commit }, sound) {
    const dialog = this._vm.g2dialog
    // build tags string
    let tagsStr = ''

    if (sound.alert) {
      tagsStr += 'alert,'
    }
    if (sound.announcement) {
      tagsStr += 'announcement,'
    }
    if (sound.bell) {
      tagsStr += 'bell,'
    }
    if (sound.playlist) {
      tagsStr += 'playlist,'
    }
    if (sound.scheduled) {
      tagsStr += 'scheduled,'
    }
    tagsStr = tagsStr.slice(0, -1)

    sound.tags = tagsStr

    api.instance.put('sounds/' + sound.sound_id, sound)
      .then(function (response) {
        if (response.data.success === 'true') {
        } else {
          dialog.$alert('Tag failed to update')
        }
      })
  },
  updateSound ({ commit }, sound) {
    return api.instance.put('sounds/' + sound.sound_id, sound)
  },
  deleteSoundFile ({ commit }, sound) {
    const dialog = this._vm.g2dialog
    api.instance.delete('sounds/' + sound.sound_id)
      .then(function (response) {
        dialog.$alert(response.data.message)

        if (response.data.success === 'true') {
          commit(types.DELETE_SOUND, sound)
        }
      })
  }
}

const mutations = {
  [types.RECEIVE_SOUNDS] (state, sounds) {
    state.sounds = _.orderBy(sounds, 'filename', 'asc')
  },
  [types.RECEIVE_SOUND_TYPES] (state, soundTypes) {
    state.sound_types = soundTypes

    for (let i = 0; i < state.sound_types.length; i++) {
      state.sound_types_for_dropdown.push({
        value: state.sound_types[i].sound_type_id,
        label: state.sound_types[i].name
      })
    }
  },
  [types.UPLOAD_SOUND] (state, sound) {
    state.sounds.push(sound)
    state.sounds = _.orderBy(state.sounds, 'filename', 'asc')
  },
  [types.DELETE_SOUND] (state, sound) {
    let soundToDelete = state.sounds.find(
      function (ele) {
        if (ele.sound_id === sound.sound_id) {
          return true
        }
      }
    )
    let index = state.sounds.indexOf(soundToDelete)
    state.sounds.splice(index, 1)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
